import { get } from 'lodash'
import titleize from 'titleize'

export default payload => {
  if (
    payload.level === 'error' ||
    payload.level === 'critical' ||
    payload.level === 'warning'
  ) {
    const exception =
      get(payload, 'body.trace.exception') ||
      get(payload, 'body.trace_chain.0.exception.description')
    if (!exception) return null

    const errorClass = exception.class || ''
    const errorDescription = exception.description || exception.message || ''
    const hashBase = `[${titleize(payload.level)}] ${errorClass} ${
      errorDescription
    }`

    payload.fingerprint = hashBase
  }
}



// WEBPACK FOOTER //
// ./common/utils/rollbar/transformer.js